import axiosInstance from '../../axios-config';

const downloadPersonalDataApi = '/api/patients/{patientId}/export';

export const getPersonalData = (patientId) => (
  axiosInstance.get(downloadPersonalDataApi.replace('{patientId}', patientId))
);
